import { cssTransition } from "react-toastify";

export const toasterTransitions = cssTransition({
  enter: "flip-vertical-right",
  exit: "slide-left",
  appendPosition: false,
  collapse: true,
  collapseDuration: 200,
});
